import { render } from "./moduleManagerView.vue?vue&type=template&id=dbbafeec"
import script from "./moduleManagerView.vue?vue&type=script&lang=js"
export * from "./moduleManagerView.vue?vue&type=script&lang=js"

import "./moduleManagerView.vue?vue&type=style&index=0&id=dbbafeec&lang=less"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__